;(function($)  {
  $(document).ready(function() {

    if (window.screenSize)
    
    $('#toc-toggle').on('click', function(e) {
      let $button = $(this);
      let wasPreviouslyExpanded = $button.attr('aria-expanded') == 'true';
      if (wasPreviouslyExpanded) {
        $button.attr('aria-expanded', 'false');
      } else {
        $button.attr('aria-expanded', 'true');
      }
    });
    
  })
})(jQuery);